<button
  type="button"
  class="trigger"
  cdkOverlayOrigin
  data-topbar-trigger="create"
  #origin="cdkOverlayOrigin"
  (click)="toggle()"
  [attr.aria-expanded]="open()"
  aria-haspopup="menu"
  data-testid="add-btn"
>
  <mat-icon>add</mat-icon>
  <span>{{ 'nav.topbar.new' | translate }}</span>
</button>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="open()"
  [cdkConnectedOverlayPositions]="[
    { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top', offsetY: 6 }
  ]"
  cdkConnectedOverlayHasBackdrop
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  (backdropClick)="onBackdropClick($event)"
  (detach)="onDetach()"
>
  @let actions = (quickActions$ | async) ?? [];
  <div class="popover" role="menu" data-testid="quick-create-panel">
    @for (action of actions; track action.id; let i = $index) {
      <ng-container *appHasAccess="action.access">
        <ng-container *appHasOwner="action.access">
          @if (startsGroup(actions, i)) {
            @if (i > 0) {
              <div class="divider"></div>
            }
            <div class="caption">{{ 'nav.topbar.create_groups.' + action.group | translate }}</div>
          }
          <button type="button" class="row" role="menuitem" (click)="run(action.id)" data-testid="menu-action-btn">
            <span class="row-icon"><mat-icon>{{ action.icon }}</mat-icon></span>
            <span class="row-label">{{ action.title | translate }}</span>
          </button>
        </ng-container>
      </ng-container>
    }
  </div>
</ng-template>
